import Vue from 'vue'
import axios from 'axios'
import api from '../api'
import router from '../../router'
import { languages } from '../language'

export const AUTH_ERROR_KEYS = {
  401: 'invalid_credentials',
  407: 'account_blocked',
  429: 'too_many_attempts',
  500: 'unknown'
}

export const state = {
  user: {},
  error: null,
  loading: false
}

function resolveAuthMessage (locale, key) {
  const safeLocale = languages[locale] ? locale : 'ro'
  return (
    languages[safeLocale]?.auth_error?.[key] ||
    languages.ro.auth_error[key] ||
    languages.ro.auth_error.unknown
  )
}

export const actions = {
  async login ({ commit, dispatch }, user) {
    commit('SET_AUTH_LOADING', true)
    try {
      const { data } = await axios.post(api.login, user)
      commit('SET_AUTH_ERROR', null)
      commit('SET_USER', data)
      dispatch('get_settings')
      await router.push('/comenzi')
    }
    catch (err) {
      const status = err?.response?.status
      const key = AUTH_ERROR_KEYS[status] || 'unknown'
      commit('SET_AUTH_ERROR', key)
      const locale = this._vm?.$store?.state?.lang || 'ro'
      const msg = resolveAuthMessage(locale, key)
      this._vm?.$toast?.error?.(msg)
    }
    finally {
      commit('SET_AUTH_LOADING', false)
    }
  },
  async check_login_by_cookie ({ commit, dispatch }, next) {
    try {
      const { data: user } = await axios(api.check_login)
      if (user.name) {
        commit('SET_USER', user)
        dispatch('get_settings')
        // first_login is consumed by the backend on this very read, so it's
        // only ever true once per account, regardless of refresh/device.
        if (user.first_login && typeof window.fbq === 'function') {
          window.fbq('track', 'CompleteRegistration')
        }
        next()
      } else { next('/login') }
    }
    catch (err) {
      next('/login')
    }
  },
  async logout ({ commit }) {
    try {
      await axios.delete(api.logout)
      commit('SET_USER', {})
      await router.push('/login')
    }
    // eslint-disable-next-line no-empty
    catch (e) {}
  },
  async change_password (context, payload) {
    const { data } = await axios.post(api.change_password, payload)
    return data
  },
  async forgot_password (context, payload) {
    const { data } = await axios.post(api.forgot_password, payload)
    return data
  },
  async reset_password (context, payload) {
    const { data } = await axios.post(api.reset_password, payload)
    return data
  }
}

export const mutations = {
  SET_USER (state, user) {
    Vue.set(state, 'user', user)
  },
  SET_AUTH_ERROR (state, value) {
    state.error = value
  },
  SET_AUTH_LOADING (state, value) {
    state.loading = value
  }
}
